import { useEffect, useRef, useState } from "react";
import {
    BrowserRouter,
    Routes,
    Route,
    useLocation,
    useNavigate,
} from "react-router-dom";
import { CSSTransition, TransitionGroup } from "react-transition-group";

import Navigation from "./Navigation";
import Home from "./Home";
import About from "./About";
import Resume from "./Resume";
import Portfolio from "./Portfolio";
import Contact from "./Contact";
import Testimonials from "./Testimonials";
import { toast } from "react-toastify";
import Certifications from "./Certification";
import {
    dummyCertifications,
    dummyPortfolios,
} from "../../Data/CloudPixDummyData";

function NotFound() {
    const navigate = useNavigate();
    useEffect(() => {
        toast.error("The page you requested was not found.");
        navigate(-1);
    }, [navigate]);
    return null;
}

const AnimatedRoutes = ({ setIsLoading }) => {
    const location = useLocation();
    const nodeRef = useRef(null);
    const [certifications, setCertifications] = useState([]);
    const [portfoliosData, setPortfoliosData] = useState([]);
    const [listCategory, setListCategory] = useState([]);

    useEffect(() => {
        const getCategories = (portfolios) => [
            "All",
            ...new Set(
                portfolios
                    .map((item) => item.type)
                    .filter(Boolean)
                    .sort(),
            ),
        ];

        const applyPortfolios = (portfolios) => {
            setPortfoliosData(portfolios);
            setListCategory(getCategories(portfolios));
        };

        const fetchInformation = async () => {
            try {
                setIsLoading(true);
                const response = await fetch(
                    "https://apicloudpix.natanaelgeraldo.com/api/certifications/get-all",
                    {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            Accept: "application/json",
                        },
                    },
                );

                const useDummyCertifications = !response.ok;
                if (!useDummyCertifications) {
                    const certifications = await response.json();
                    setCertifications(
                        Array.isArray(certifications)
                            ? certifications
                            : dummyCertifications,
                    );
                } else {
                    setCertifications(dummyCertifications);
                }

                const responsePortfolios = await fetch(
                    "https://apicloudpix.natanaelgeraldo.com/api/portfolios/get-all",
                    {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            Accept: "application/json",
                        },
                    },
                );

                if (!responsePortfolios.ok) {
                    throw new Error(
                        `HTTP error! Status: ${responsePortfolios.status}`,
                    );
                }

                const portfolios = await responsePortfolios.json();
                applyPortfolios(
                    Array.isArray(portfolios) ? portfolios : dummyPortfolios,
                );

                if (useDummyCertifications) {
                    toast.warn(
                        "API certifications gagal. Menggunakan data dummy lokal.",
                    );
                }
            } catch (error) {
                console.error("Error fetching:", error);
                setCertifications(dummyCertifications);
                applyPortfolios(dummyPortfolios);
                // toast.warn("API gagal. Menggunakan data dummy lokal.");
            } finally {
                setIsLoading(false);
            }
        };

        fetchInformation();
    }, [setIsLoading]);

    return (
        <TransitionGroup component={null}>
            <CSSTransition
                key={location.pathname}
                nodeRef={nodeRef}
                classNames="fade"
                timeout={500}
            >
                <div ref={nodeRef} className="route-wrapper">
                    <Routes location={location}>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/experience" element={<Resume />} />
                        <Route path="/testimonials" element={<Testimonials />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route
                            path="/projects"
                            element={
                                <Portfolio
                                    portfolios={portfoliosData}
                                    categories={listCategory}
                                />
                            }
                        />
                        <Route
                            path="/certification"
                            element={
                                <Certifications
                                    certifications={certifications}
                                />
                            }
                        />
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </div>
            </CSSTransition>
        </TransitionGroup>
    );
};

const Content = ({ setIsLoading }) => {
    return (
        <BrowserRouter>
            <div
                className="transition-all duration-500 min-w-[270px] max-w-[900px] w-full lg:ml-8 mt-8 lg:mt-0 rounded-3xl overflow-hidden text-left text-white pb-28 lg:pb-0"
                style={{
                    background: "rgba(255,255,255,0.04)",
                    border: "1px solid rgba(255,255,255,0.09)",
                    backdropFilter: "blur(16px)",
                    WebkitBackdropFilter: "blur(16px)",
                    boxShadow:
                        "0 8px 32px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.04)",
                }}
            >
                {/* Gold accent bar — matches SideProfile */}
                <div
                    style={{
                        height: "2px",
                        background:
                            "linear-gradient(90deg, transparent 0%, #C8972A 40%, #F0C060 50%, #C8972A 60%, transparent 100%)",
                        opacity: 0.7,
                    }}
                />
                <div className="px-7 py-6">
                    <Navigation />
                    <AnimatedRoutes setIsLoading={setIsLoading} />
                </div>
            </div>
        </BrowserRouter>
    );
};

export default Content;
